import { createElement } from 'react';

/**
 * Wrapper genérico de "contenedor con borde". Excepción al patrón editorial
 * (rules > cards) — usar solo cuando la metáfora de "objeto contenido" sí
 * aplica: lista de PAEs guardados, paywall, install prompt PWA, paneles
 * discretos en ajustes.
 *
 * Prohibido envolver diagnósticos, formularios o listas Henderson — esos
 * van con <DiagnosticArticle> / <Field> o como fila editorial.
 *
 * Los CUATRO roles de contenedor del producto (ola de profesionalización,
 * decisión 5 del fundador): PROTAGONISTA (una por pantalla, la card grande
 * que contesta "qué toca ahora" — variant='protagonista'), ESTÁNDAR (borde +
 * papel, acompaña — variant='default'), FILA EDITORIAL (listas: border-b y
 * hover, sin caja — no es Card, ver el patrón de "salidas" del hub) y CHIP
 * (rounded-full — <Chip>). Si una pantalla necesita una caja que no calza en
 * ninguno de los cuatro, la pregunta es por qué.
 *
 * @param {Object} props
 * @param {'default'|'surface'|'accent'|'protagonista'} [props.variant='default']
 * @param {'sm'|'md'|'lg'|'none'} [props.padding='md']
 * @param {string} [props.as='div']  Tag HTML a renderizar.
 * @param {string} [props.className='']  Solo overrides menores (mb-4, max-w-md…).
 *                                        No para color.
 * @param {React.ReactNode} props.children
 */
export default function Card({
  variant = 'default',
  padding = 'md',
  as = 'div',
  className = '',
  children,
}) {
  const variantClass = VARIANTS[variant] || VARIANTS.default;
  const paddingClass = PADDINGS[padding] ?? PADDINGS.md;

  return createElement(
    as,
    {
      className: [
        variantClass,
        paddingClass,
        'rounded-tk-md',
        className,
      ].filter(Boolean).join(' '),
    },
    children
  );
}

const VARIANTS = {
  default: 'bg-paper border border-edge',
  surface: 'bg-surface',
  accent:  'bg-accent-bg border border-accent-border',
  // La protagonista: gradiente sutil accent→papel, una sola por pantalla.
  // Mismo lenguaje que EL MOMENTO del Home y el hub de MiPAE en turno.
  protagonista: 'border border-accent-border bg-gradient-to-br from-accent-bg via-paper to-paper',
};

const PADDINGS = {
  none: '',
  sm:   'p-3',
  md:   'p-5',
  lg:   'p-6',
};
